import React from 'react';
import * as ReactDOM from 'react-dom';
import classnames from 'classnames';
import Icon from '../icon/index';
import ToastContainer from './ToastContainer';
class ToastModal extends React.Component {
    constructor() {
        super(...arguments);
        this.getIcon = (type) => {
            let icon = null;
            switch (type) {
                case 'loading':
                    icon = <Icon type="loading" size='xlg' style={{ color: '#00a600' }}/>;
                    break;
                case 'success':
                    icon = <Icon type="success" size="lg" style={{ color: '#00a600' }}/>;
                    break;
                case 'error':
                    icon = <Icon type="error" size='lg' style={{ color: '#F15440' }}/>;
                    break;
                case 'info':
                    icon = null;
                    break;
                default:
                    icon = null;
            }
            return icon;
        };
        // 展开时防止body滚动
        this.bodyDisaleScroll = (e) => {
            e.preventDefault();
        };
    }
    componentDidMount() {
        const { close, duration, type } = this.props;
        if (type !== 'loading') { // loading 不自动关闭
            this.timer = setTimeout(() => {
                close();
            }, duration);
        }
    }
    componentWillUnmount() {
        if (this.timer)
            clearTimeout(this.timer);
    }
    render() {
        const { visible, content, type, className } = this.props;
        const toastCls = classnames('cfm_toast', className);
        return (<ToastContainer visible={visible} className={toastCls}>
        <div onTouchMove={this.bodyDisaleScroll} className='cfm_toast_warp'>
          <div className='cfm_toast_content'>
            <div>
              {this.getIcon(type)}
              <div>{content}</div>
            </div>
          </div>
        </div>
      </ToastContainer>);
    }
}
ToastModal.defaultProps = {
    duration: 2000,
    type: 'info',
};
let toastList = [];
function hiddenAll() {
    if (toastList && toastList.length) {
        toastList.forEach((item) => {
            item.destroy();
        });
    }
    toastList = [];
}
function toast(config) {
    if (!document) {
        return;
    }
    const div = document.createElement('div');
    document.body.appendChild(div);
    let currentConfig = Object.assign(Object.assign({}, config), { close, visible: true });
    function close(...args) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), { visible: false });
        render(currentConfig);
        config.onHidden && config.onHidden();
        setTimeout(() => {
            destroy(...args);
        }, 300);
    }
    function update(newConfig) {
        currentConfig = Object.assign(Object.assign({}, currentConfig), newConfig);
        render(currentConfig);
    }
    function destroy(...args) {
        const unmountResult = ReactDOM.unmountComponentAtNode(div);
        if (unmountResult && div.parentNode) {
            div.parentNode.removeChild(div);
        }
        const triggerHidden = args && args.length && args.some(param => param && param.triggerHidden);
        if (config.onHidden && triggerHidden) {
            config.onHidden(...args);
        }
    }
    function render(props) {
        ReactDOM.render(<ToastModal {...props}/>, div);
    }
    // 防止重复提示
    hiddenAll();
    render(currentConfig);
    const toastItem = {
        destroy: close,
        update,
    };
    toastList.push(toastItem);
    return toastItem;
}
export default {
    success: (content, duration, onHidden) => {
        return toast({
            type: 'success',
            content,
            duration,
            onHidden,
        });
    },
    error: (content, duration, onHidden) => {
        return toast({
            type: 'error',
            content,
            duration,
            onHidden,
        });
    },
    info: (content, duration, onHidden) => {
        return toast({
            type: 'info',
            content,
            duration,
            onHidden,
        });
    },
    loading: (content, onHidden) => {
        return toast({
            type: 'loading',
            content,
            onHidden,
        });
    },
    hiddenAll,
    open: toast,
};



// WEBPACK FOOTER //
// ./components/toast/index.tsx